import store from '../store'
import { IWish, IStation, WishType, ILocation } from 'types'

export type Wish = {
  id: string
  user: string
  lat: number
  lng: number
  type: string
  createdAt: number
}

export interface IWishesState {
  wishes: IWish[]
  currentLocation: ILocation | undefined
  isLoading: boolean
}

const initialState: IWishesState = {
  wishes: [],
  currentLocation: undefined,
  isLoading: false,
}

export const wishes = {
  effects: {
    async getCurrentLocation() {
      const { dispatch } = store
      dispatch.wishes.setLoadingState(true)

      if (window.navigator) {
        window.navigator.geolocation.getCurrentPosition(
          pos => {
            dispatch.wishes.setCurrentLocation({
              lat: pos.coords.latitude,
              lng: pos.coords.longitude,
            })
            dispatch.wishes.setLoadingState(false)
          },
          err => {
            console.log(err)
          }
        )
      }
    },
  },
  reducers: {
    addWish(state: IWishesState, data: IWish) {
      return {
        wishes: [...state.wishes, data],
      }
    },
    setLoadingState(state: IWishesState, data: boolean) {
      return {
        ...state,
        loading: data,
      }
    },
    setCurrentLocation(state: IWishesState, location: ILocation) {
      return {
        ...state,
        currentLocation: location,
      }
    },
  },
  state: initialState,
}



// WEBPACK FOOTER //
// ./src/models/wishes.ts